module.exports = __webpack_public_path__ + "static/media/10.42ac6484.jpg";